export const k = {
    dialogHeaderStart: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.dialogHeaderStart",
    dialogHeaderEnd: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.dialogHeaderEnd",
    previewButton: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.previewButton",
    rejectButton: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.rejectButton",
    forwardButton: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.forwardButton",
    saveChangesButton: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.saveChangesButton",
    approveButton: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.approveButton",
    closeButton: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.closeButton",
    functionHelpText: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.functionHelpText",
    dynamicInvoiceDialogHelp: "domains.dynamic-invoice.pages.dynamic-invoice-page.components.dynamic-invoice-dialog.dynamic-invoice-dialog-i18n.dynamicInvoiceDialogHelp"
};
export const translations = {
    da: {
        dialogHeaderStart: "Sag {{ matterId }}",
        dialogHeaderEnd: "Faktura godkendelse",
        previewButton: "Preview",
        rejectButton: "Afvis faktura",
        forwardButton: "Videregiv faktura",
        saveChangesButton: "Gem ændringer",
        approveButton: "Godkend faktura",
        closeButton: "Luk",
        functionHelpText: "Hjælp til funktioner",
        dynamicInvoiceDialogHelp: "Detaljer"
    },
    en: {
        dialogHeaderStart: "Matter {{ matterId }}",
        dialogHeaderEnd: "Invoice approval",
        previewButton: "Preview",
        rejectButton: "Reject invoice",
        forwardButton: "Forward invoice",
        saveChangesButton: "Save changes",
        approveButton: "Approve invoice",
        closeButton: "Close",
        functionHelpText: "Help functions",
        dynamicInvoiceDialogHelp: "Details"
    }
};
